module.exports = __webpack_public_path__ + "static/media/feather-loader.f366e59d.svg";